/**
 * Stable id for a committed Action Plan play (SYR-68, Phase 4).
 *
 * The Briefing AI's recommendations regenerate when scope/data changes, so a
 * play's array position is not stable. We key a committed play by a
 * deterministic hash of its identity — its title plus the elements it "moves" —
 * so the same recommendation maps to the same id across regenerations, scope
 * changes and devices. The Action Plan persists snapshots under this id, and the
 * Recommendations grid uses it to know which live cards are already committed.
 */

import type { Recommendation } from './components/RecommendationCard';

export function playStableId(card: Recommendation): string {
  const moves = (card.objectives ?? []).map((o) => o.moves ?? '').join(',');
  const seed = `${(card.title ?? '').trim().toLowerCase()}|${moves
    .trim()
    .toLowerCase()}`;
  // djb2 — small, deterministic, dependency-free.
  let hash = 5381;
  for (let i = 0; i < seed.length; i += 1) {
    hash = ((hash << 5) + hash + seed.charCodeAt(i)) >>> 0;
  }
  return `p_${hash.toString(36)}`;
}
